import request from "../utils/request";

export function deleteCollectionList(ids) {
    return request({
        url: `/collection/deleteList`,
        method: 'delete',
        data:ids
    })
}

export function getCollectionPage(data,pageNum,pageSize) {
    return request({
        url: `/collection/findPage`,
        method: 'post',
        params: { pageNum: pageNum,pageSize:pageSize },
        data:data
    })
}
